import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import AddressModal from "./fourthTrimesterOnesieGift";
import "react-datepicker/dist/react-datepicker.css";
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";

const FourthTrimesterNumberOfBabies = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedBabies, setSelectedBabies] = useState(null);
  const [showAddressModal,setShowAddressModal] = useState(false);
  const [error, setError] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
const [deliveryDateError, setDeliveryDateError] = useState(false);
  const handleSelection = (event) => {
    setSelectedBabies(event.target.value);
    setError(false);
  };

  const handleNext = () => {
    if (selectedBabies && deliveryDate) {
      setShowAddressModal(true)
    } else if (!deliveryDate) {
      setDeliveryDateError(true);
    }else {
      setError(true);
    }
  };
//   const step = 1;
// const totalSteps = 4;
// const disableNext = !selectedBabies;
  const handleDateSelect = (date) => {
    // Convert date to mm/dd/yyyy format
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    const formatted = `${mm}/${dd}/${yyyy}`;
    setDeliveryDate(formatted);
    setDeliveryDateError(false);  //set error to false when a date is selected
  };

  const handleBack = () => {
    navigate("/fourth-trimester-landing-page");
  };
  const handleAddressModalClose = () => {
    setShowAddressModal(false);
}

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

  return (
    <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
          <h1>What was your delivery date?</h1>
          <DatePicker
                    selected={deliveryDate ? new Date(deliveryDate) : null}
                    dateFormat="MM/dd/yyyy"
                    className="form-control win-form-control mobile-view calendar-control mb-4"
                    id="due-date"
                    onChange={handleDateSelect}
                    placeholderText="MM/DD/YYYY"
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={50}
                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                    maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 50))}
                    autoComplete="off"
                    onKeyDown={(e) => e.preventDefault()}
                  />
           {deliveryDateError && <p className="text-danger text-center">Please select the delivery Date.</p>}
            <h3 className="page-heading-secondary-black mb-5">{t('oneOrMoreBabies')}</h3>
{/* <p>{t('didYouHaveBaby')}</p> */}
            {/* <h4 className="page-heading-secondary-black mt-5">{t('oneOrMoreBabies')}</h4> */}

            <div className="container mt-3 mb-5">
              <div className="row">
                {[1, 2, 3, 4].map((num) => (
                  <div key={num} className="col-6 d-flex justify-content-center mb-3">
                    <input
                      type="radio"
                      id={`option${num}`}
                      name="options"
                      value={num}
                      className="radio-input"
                      onChange={handleSelection}
                    />
                    <label htmlFor={`option${num}`} className="radio-label">
                      {num}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            {error && <p className="text-danger text-center">Please select the number of babies.</p>}

            <div className="mt-3 mb-5 d-flex justify-content-between align-items-center">
              {isHighmarkPortal ? (
                <div className="pagination-wrapper mt-5">
                  <button className="previous-btn" onClick={handleBack} style={{ cursor: 'pointer' }}></button>
{/* <span className="pagination-status">{`${step} of ${totalSteps}`}</span> */}
                  <span className="pagination-status">1 of 2</span>
                  <button className="next-btn" onClick={handleNext}
                    style={{ cursor: selectedBabies ? 'pointer' : 'not-allowed', opacity: selectedBabies ? 1 : 0.5 }}
                  >
                  </button>
                </div>
              ) :(
                
                <>
                <button
                  className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0"
                  onClick={handleBack}
                  type="button"
                >
                  {t('back')}
                </button>
                <button
                  className="win-btn-primary mobile-view me-3 mb-2 mb-md-0"
                  onClick={handleNext}
                >
                  {t('next')}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
      <AddressModal isOpen={showAddressModal}  onClose={handleAddressModalClose} deliveryDate={deliveryDate}  selectedBabies={selectedBabies} />
    </>
  );
};

export default FourthTrimesterNumberOfBabies;
